import React from 'react';
import { useLang } from '../context/LanguageContext';
import styles from './LanguageSwitcher.module.css';

export default function LanguageSwitcher({ theme = 'dark' }) {
  const { lang, setLang } = useLang();
  const toggle = () => setLang(lang === 'en' ? 'es' : 'en');

  return (
    <button className={`${styles.toggle} ${styles[theme]}`} onClick={toggle} aria-label="Switch language">
      {lang.toUpperCase()}
    </button>
  );
}
